import React from 'react';
import { useEffect, useRef } from 'react';
import { DocumentEditorContainerComponent, Toolbar } from '@syncfusion/ej2-react-documenteditor';
import { syncServiceUrl } from '../utils/Constant';

DocumentEditorContainerComponent.Inject(Toolbar);
const CompareFileSFDT = () => {
    let hostUrl = `${syncServiceUrl}api/documenteditor/`
    let container = useRef(null);
    let sfdt = localStorage.getItem('diff_sfdt');
    if (sfdt) {
        try {
            sfdt = JSON.stringify(JSON.parse(sfdt)); // ensure valid
        } catch (err) {
            console.error("Invalid SFDT:", err);
        }
    }

    useEffect(() => {
        rendereComplete();
    }, []);

    const onLoadDefault = () => {
        let defaultDocument = {
            sfdt: sfdt
        };
        container.current.documentEditor.open(JSON.stringify(defaultDocument));
        container.current.documentChange = () => {
            container.current.documentEditor.focusIn();
        };
    };
    const rendereComplete = () => {
        window.onbeforeunload = function () {
            return "Want to save your changes?";
        };
        container.current.documentEditor.pageOutline = "#E0E0E0";
        container.current.documentEditor.acceptTab = true;
        container.current.documentEditor.resize();
        onLoadDefault();
    };
    return (
        <div className="editor-wrapper" style={{ height: "100vh", display: "flex", flexDirection: "column", }}>
            <div id="documenteditor_container_body" className="editor-body " style={{ flex: "1 1 auto", overflow: "hidden" }}>
                <DocumentEditorContainerComponent id="container" enableToolbar={false} ref={container} height="100%" serviceUrl={hostUrl} showPropertiesPane={false} locale="en-US" />
            </div>
        </div>
    );
};
export default CompareFileSFDT;
